import React from "react";
import Twitteratis from "../../assets/twitteratis.png";
import Mukul from "../../assets/mukul.png";
import expClassplus from "../../assets/experienceClassplus.png";
import maxResDefault from "../../assets/maxresdefault4.png";
import SenseOfPurpose5 from "../../assets/SenseOfPurpose5.png";
import "./KnowMoreSection.scss";
const KnowMoreSection = () => {
	const gotoTwitterHandler = () => {
		window.open(
			"https://twitter.com/sajithpai/status/1408700975859179520?s=20",
			"_blank"
		);
	};

	const surgeHandler = () => {
		window.open(
			"https://www.facebook.com/GetReadyToSurge/videos/264163171292596/",
			"_blank"
		);
	};

	const knowTheClanHandler = () => {
		window.open(
			"https://www.linkedin.com/feed/update/urn:li:activity:6857590969492152320",
			"_blank"
		);
	};

	const futurePlansHandler = () => {
		window.open("https://www.youtube.com/watch?v=3aHVf3ccuuU&t=18s", "_blank");
	};
	const foundSenseHandler = () => {
		window.open(
			"https://classplus.medium.com/i-found-a-sense-of-purpose-at-classplus-3b4ebd8ff19",
			"_blank"
		);
	};
	return (
		<div className='KnowMore__section'>
			<h3>Know more about us</h3>
			<div className='KnowMore__section__images'>
				{/* <Link to='https://twitter.com/sajithpai/status/1408700975859179520?s=20 '> */}
				<div
					className='KnowMore__section__images__singleImageWithText'
					onClick={gotoTwitterHandler}
				>
					<img src={Twitteratis} alt='blumeVenture' />
					<h4>Sajith Pai, VC at Blume Venture</h4>
				</div>{" "}
				{/* </Link> */}
				<div
					className='KnowMore__section__images__singleImageWithText'
					onClick={surgeHandler}
				>
					<img src={Mukul} alt='Sequoia' />
					<h4>Classplus | Sequoia</h4>
				</div>
				<div
					className='KnowMore__section__images__singleImageWithText'
					onClick={knowTheClanHandler}
				>
					<img src={expClassplus} alt='Know the Clan' />
					<h4>Know the Clan</h4>
				</div>
			</div>
			<div className='KnowMore__section__images'>
				<div
					className='KnowMore__section__images__otherSection'
					onClick={futurePlansHandler}
				>
					<img src={maxResDefault} alt='Know the Clan' />
					<h4>Our future plans</h4>
				</div>
				<div
					className='KnowMore__section__images__otherSection'
					onClick={foundSenseHandler}
				>
					<img src={SenseOfPurpose5} alt='Know the Clan' />
					<h4>Found a sense of purpose at Classplus</h4>
				</div>
			</div>
		</div>
	);
};

export default KnowMoreSection;
